<template>
  <md-card>
    <md-card-content>
      <autoextra :collection="service" v-slot="{item,last,index}">
        <div class="columns" :class="{last: last}">
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-100">
              <label class="label">{{last ? 'New ' : ''}}Service {{!last ? index + 1 : ''}}</label>
              <span id="flagServiceType" style="display:none; color:red;">Field is required</span>
            </div>
            <div class="md-layout-item md-size-10">
              <md-button class="md-primary md-round md-dense" v-on:click="findService(index)">Find Service</md-button>
            </div>
          </div>
          
          <div class="md-layout md-gutter">
            <input v-model="item.id" :readonly="true" type="hidden"/>
            <input v-model="item.service_estimate_service_master_id" :readonly="true" type="hidden"/>
            
            <!-- <div class="md-layout-item md-small-size-100">
              <md-field class="md-invalid">
                <label class="label" >Service Name</label>
                <validation-provider  rules="servicename" ref="service_master_name"  v-slot="{ errors }">
                <md-select v-model="item.service_estimate_service_master_id" @md-selected="onChangeService(index, $event)" @focus="focusSelectChanged(index)">
                <md-option v-for="option in options_service_list" :key="option.value" :value="option.id">
                  {{ '('+option.service_master_code+') '+option.service_master_name }}
                </md-option>
                </md-select>
                
                <span >{{ errors[0] }}</span>
                </validation-provider>
              </md-field>
            </div> -->

              
            <div class="md-layout-item md-small-size-100">
              <md-field >
                <label class="label" >Service Name</label>
                <validation-provider   ref="service_master_name"  v-slot="{ errors }">
                  <md-input  v-model="item.name" :readonly="true"/>
                  <span >{{ errors[0] }}</span>
                </validation-provider>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100">
              <md-field >
                <label class="label" >Service Code</label>
                <md-input  v-model="item.code" :readonly="true"/>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100">
              <md-field >
                <label class="label" >LTS</label>
                <md-input  v-model="item.lts" :readonly="true"/>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100">
              <md-field >
                <label class="label" >Discount(%)</label>
                <md-input v-model="item.service_estimate_service_discount" @change="discountChange(index,item.service_estimate_service_discount)" type="text" v-on:keypress="NumbersOnly"/>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100">
              <md-field >
                <label class="label" >Price</label>
                <md-input  v-model="item.price" :readonly="true"/>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100">
              <md-field >
                <label class="label" >Total</label>
                <md-input  v-model="item.total" :readonly="true"/>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100">
              <md-field >
                <label class="label" >Remarks</label>
                <md-input  v-model="item.service_estimate_service_remark" />
              </md-field>
            </div>
            
          
            <md-button class="md-danger md-dense" @click="deleteColumn(index)" v-if="item.code">
              delete
            </md-button>
          
          </div>       
        </div>
      </autoextra>
    </md-card-content>
    <modal ref="modalList" class="coba">
      <template v-slot:header>
        <div>
          <h3>List Service</h3>
        </div>
        <md-button class="md-dense md-round md-icon-button" @click="CloseListService()"><md-icon>close</md-icon></md-button>
      </template>

      <template v-slot:body>
        <list-service  :data_id="$refs.modalList.data"/>
      </template>

      <template v-slot:footer>
        <md-card-actions>
          <md-button @click="modalCloseList">
            Close
          </md-button>
        </md-card-actions>
      </template>
    </modal>
  </md-card>  
        
</template>
<script>
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";
import  Autoextra  from 'vue-autoextra';
import {extend} from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import ListService from "@/pages/Dashboard/Workshop/ServiceEstimate/ComponentForm/modal/ListService.vue";
import { Modal } from "@/components";

extend('servicename', {
  ...required,
  message: 'Please Select. Service is required'
  });

export default {
  name: "service-card",

  // props: {
  //   service_estimate: null,
  // },
  props: ['service_estimate'],
  components: { Autoextra, Modal, "list-service": ListService },

  mixins: [formMixin],

  data () {
    return {
      service: [],
      //options_service_list: null,
      index_modal: null,
    }
  },
  // watch: {
  //     service: function (newVal) {
  //       //Deteksi perubahan di service untuk di kirim ke parent
  //       this.$emit('data', newVal)
  //     }

  //   },
  
  created() {
          this.onOpen()
      },
   methods:{
     //fungsi yang dipanggil saat page pertamakali dibuka
     async onOpen(){
       
        //ambil list service dari server
      //   await this.$store.dispatch("workshop_service_master/list")
        
      //  this.options_service_list = await this.$store.getters["workshop_service_master/list"]
      },

      NumbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
  

      findService(index){
        this.index_modal = index
        this.$refs.modalList.openModal()
      },

      CloseListService(){
        this.$refs.modalList.closeModal();
      },
      
      //fungsi untuk menutup modal list
      modalCloseList(data){
       console.log(data)
        this.$refs.modalList.closeModal()
        if(data.id){
          let error = document.getElementById("flagServiceType");
        error.style.display = "none"
            if(this.service[this.index_modal]){
          
            this.$set(this.service, this.index_modal, {
                id : this.service[this.index_modal].id,
                service_estimate_service_master_id : data.id,
                name : data.service_master_name,
                code : data.service_master_code,
                lts : data.service_master_lts,
                price : data.service_category_standard_cost,
                service_estimate_service_discount : this.service[this.index_modal].service_estimate_service_discount,
                total : (data.service_category_standard_cost * data.service_master_lts) - ((data.service_category_standard_cost * data.service_master_lts) * this.service[this.index_modal].service_estimate_service_discount/100),
                service_estimate_service_remark : this.service[this.index_modal].service_estimate_service_remark
              });
            }
            else{
              
            this.$set(this.service, this.index_modal, {
                id : null,
                service_estimate_service_master_id : data.id,
                name : data.service_master_name,
                code : data.service_master_code,
                lts : data.service_master_lts,
                price : data.service_category_standard_cost,
                service_estimate_service_discount : null,
                total : data.service_category_standard_cost * data.service_master_lts,
                service_estimate_service_remark : null
              });
            }
        }
        
      },

      //fungsi untuk menghapus row service
      deleteColumn(index){
        if (index > -1) {
           //this.service.splice(index, 1)
          this.$delete(this.service, index,1)
          var filtered = this.service.filter(function (el) {
            return el != null;
          });
          this.service = filtered;
        }
        console.log(this.service);
        
      },
      // //fungsi yang berjalan ketika ada perubahan focus di select item service
      // focusSelectChanged(index){
      //   //check apakah var part dengan index item yang di select ada
      //   if(this.service[index]){
      //       //cari nomor index dari var options_service_list berdasarkan id item yang di select
      //       var indexOption = this.options_service_list.findIndex(p => p.id == this.service[index].service_estimate_service_master_id)
      //        //set var service dengan index sesuai dengan yang di pilih 
      //       this.$set(this.service, index, {
      //       id : null,
      //       service_estimate_service_master_id : this.service[index].service_estimate_service_master_id,
      //       code : this.options_service_list[indexOption].service_master_code,
      //       lts : this.options_service_list[indexOption].service_master_lts,
      //       price : this.options_service_list[indexOption].service_category_standard_cost,
      //       service_estimate_service_discount : null,
      //       total : this.options_service_list[indexOption].service_category_standard_cost * this.options_service_list[indexOption].service_master_lts,
      //       service_estimate_service_remark : null
      //     });
      //     }
        
      // },
      //  //fungsi ketika ada perubahan di select item service
      // onChangeService(index,event){
      //   //check apakah niali event tidak null
      //   if(event){
      //     //cari nomor index dari var options_service_list berdasarkan item yang di select
      //   var indexOption = this.options_service_list.findIndex(p => p.id == event)
      //   //check apakah var service dengan index yang dipilih memiliki data remark dan dicount
      //   if(this.service[index] && (this.service[index].service_estimate_service_remark || this.service[index].service_estimate_service_discount)){
      //      this.$set(this.service, index, {
      //       id : this.service[index].id,
      //       service_estimate_service_master_id : this.service[index].service_estimate_service_master_id,
      //       code : this.service[index].code,
      //       lts : this.service[index].lts,
      //       price : this.service[index].price,
      //       service_estimate_service_discount : this.service[index].service_estimate_service_discount,
      //       total : (this.service[index].price * this.service[index].lts) - ((this.service[index].price * this.service[index].lts) * this.service[index].service_estimate_service_discount/100),
      //       service_estimate_service_remark : this.service[index].service_estimate_service_remark
      //     });
      //     console.log('yahoo')
      //   }
      //   else{
      //       //jika tidak ada set sesuai dengan nilai yang di dapat dari options_service_list dengan nomor index yang sudah didapatkan sebelumnya
      //     this.$set(this.service, index, {
      //       id : null,
      //       service_estimate_service_master_id : event,
      //       name : this.service[index].name,
      //       code : this.options_service_list[indexOption].service_master_code,
      //       lts : this.options_service_list[indexOption].service_master_lts,
      //       price : this.options_service_list[indexOption].service_category_standard_cost,
      //       service_estimate_service_discount : null,
      //       total : this.options_service_list[indexOption].service_category_standard_cost * this.options_service_list[indexOption].service_master_lts,
      //       service_estimate_service_remark : null
      //     });
      //     //console.log('bahoo')
      //   }
        

      // }
      //   },
        //fungsi ketika ada perubahan di input discount, index nomor urut row
        discountChange(index,discount){
           //check apakah nilai discount tidak null
          if(discount){

         // var indexOption = this.options_service_list.findIndex(p => p.id == this.service[index].service_estimate_service_master_id)
         //set var service dengan data yang telah ada sesuai dengan nomor indexnya dengan perubahan di discount dan total
         this.$set(this.service, index, {
                id : this.service[index].id,
                service_estimate_service_master_id : this.service[index].service_estimate_service_master_id,
                name : this.service[index].name,
                code : this.service[index].code,
                lts : this.service[index].lts,
                price : this.service[index].price,
                service_estimate_service_discount : discount,
                total : (this.service[index].price * this.service[index].lts) - ((this.service[index].price * this.service[index].lts) * discount/100),
                service_estimate_service_remark : this.service[index].service_estimate_service_remark
              });
            
       
          }

        },
     //fungsi yang di panggil dari sisi parent untuk mendapatkan data yang ada di page child ini    
    getData() {
        this.$emit('data', this.service)
    },
      //fungsi untuk mendapatkan data dari parent, digunakan saat edit
    async getDataParent() {
      //check apakah options_service_list null
      // if(!this.options_service_list){
      //   //jika null ambil data service_list dari server
      //   await this.$store.dispatch("workshop_service_master/list")
      //   this.options_service_list = await this.$store.getters["workshop_service_master/list"]
      // }
     
       console.log (this.service_estimate.service_estimate_service)
       //this.service= this.service_estimate.service_estimate_service

        //loop untuk mengeset data row service
       this.service_estimate.service_estimate_service.forEach((value, index) => {
        //var indexOption = this.options_service_list.findIndex(p => p.id == value.service_estimate_service_master_id)
        // this.$set(this.service, index, {
        //     id : value.id,
        //     service_estimate_service_master_id : value.service_estimate_service_master_id,
        //     code : this.options_service_list[indexOption].service_master_code,
        //     lts : this.options_service_list[indexOption].service_master_lts,
        //     price : this.options_service_list[indexOption].service_category_standard_cost,
        //     service_estimate_service_discount :  value.service_estimate_service_discount,
        //     total : (this.options_service_list[indexOption].service_category_standard_cost * value.service_master_lts) - ((this.options_service_list[indexOption].service_category_standard_cost * value.service_master_lts) * value.service_estimate_service_discount/100),
        //     service_estimate_service_remark : value.service_estimate_service_remark
        //   });

        
        this.$set(this.service, index, {
            id : value.id,
            service_estimate_service_master_id : value.service_estimate_service_master_id,
            name : value.service_master_name,
            code : value.service_master_code,
            lts : value.service_master_lts,
            price : value.service_category_standard_cost,
            service_estimate_service_discount :  value.service_estimate_service_discount,
            total : (value.service_category_standard_cost * value.service_master_lts) - ((value.service_category_standard_cost * value.service_master_lts) * value.service_estimate_service_discount/100),
            service_estimate_service_remark : value.service_estimate_service_remark
          });

      });
    },

    //fungsi yang di panggil dari sisi parent untuk mengecheck validasi form di page child ini
    async validateForm() {
            const service_master_name = this.$refs['service_master_name'];
          let result = []
            //   if(this.service.length == 0){
            // result.push(
            //     await service_master_name.validate().then(function(data){
            //     return data.valid
            //     })
            // )
            //   } 


            if(Object.keys(this.service).length != 0){
              if(!this.service[0].service_estimate_service_master_id){
                document.getElementById("flagServiceType").style.display = "block"
              result.push(false)
                }
              }

            if(Object.keys(this.service).length == 0){
                    document.getElementById("flagServiceType").style.display = "block"
                    result.push(false)
              }
            
            return result.every(Boolean)
          
    }
        

    },
    mounted() {
        console.log('Component mounted.')
    }
};
</script>

<style lang="scss" scoped>

.columns{
  margin-bottom: 3ex;
  border-bottom: 5px solid black;
}

.coba{
  width:800px !important;
  margin: 50px auto !important;
  
  @media screen and (max-width: 992px) {
      width: 90% !important;
    }
}
</style>
